import { all, takeLatest } from 'redux-saga/effects';
import AutoSaveSaga from './customization';
import { ActionTypes as autoSaveActionTypes } from '../actions/customization/autosave';

function* cardsRootSaga() {
  yield all([
    takeLatest(autoSaveActionTypes.AUTOSAVE_REQUEST, AutoSaveSaga),
  ]);
}

export default cardsRootSaga;



// WEBPACK FOOTER //
// ./src/cards/sagas/index.js